export default __webpack_public_path__ + "static/straingeBeast-logo-2d777f6f307cfd908e876d6818b65a89.svg";